/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListInboxThreadsChannel } from './listInboxThreadsChannel';
import type { ListInboxThreadsTab } from './listInboxThreadsTab';

export type ListInboxThreadsParams = {
tab?: ListInboxThreadsTab;
channel?: ListInboxThreadsChannel;
cursor?: string | null;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};
